import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';

const lang = localStorage.getItem('languagePreference') || 'en-GB';
i18n
  .use(Backend)
  .use(initReactI18next)
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: lang,
    debug: true,
    fallbackLng: 'en-GB',
    load: 'currentOnly'
  });

export default i18n;
